/*
  References:
  Seller Central Prod doamins: https://monster.mons.amazon.dev/sites/sellerCentral
  https://w.amazon.com/bin/view/List_of_Amazon_domains/
*/

const validDomains = [
  'a100dco.com', 'a2z.com',
  'a9.com',
  'abebooks.com',
  'alexa.com',
  'amazon.ae',
  'amazon.at',
  'amazon.ch',
  'amazon.co.jp',
  'amazon.co.th',
  'amazon.co.uk',
  'amazon.com',
  'amazon.com.ar',
  'amazon.com.au',
  'amazon.com.bh',
  'amazon.com.tr',
  'amazon.com.vn',
  'amazon.cz',
  'amazon.de',
  'amazon.es',
  'amazon.fi',
  'amazon.fr',
  'amazon.id',
  'amazon.in',
  'amazon.it',
  'amazon.lu',
  'amazon.my',
  'amazon.nl',
  'amazon.ph',
  'amazon.pl',
  'amazon.pt',
  'amazon.ro',
  'amazon.sa',
  'amazonstudios.com',
  'appario.in',
  'audible.co.jp',
  'audible.co.uk',
  'audible.com',
  'audible.com.au',
  'audible.de',
  'audible.fr',
  'audible.it',
  'bookdepository.com',
  'brillianceaudio.com',
  'brilliancepublishing.com',
  'buyvip.com',
  'cbre.com',
  'cloudtail.biz',
  'cloudtail.in',
  'comixology.com',
  'createspace.com',
  'dpreview.com',
  'electronicsbazaar.com',
  'elemental.com',
  'etradeonline.in',
  'fabric.com',
  'goodreads.com',
  'imdb.com',
  'ivona.com',
  'lab126.com',
  'lovefilm.com',
  'nwcdcloud.cn',
  'pillpack.com',
  'quidsi.com',
  'rc1-cricket-placeholder.com',
  'ring.com',
  'shopbop.com',
  'sizmek.com',
  'souq.com',
  'twitch.tv',
  'vrptl.in',
  'wondery.com',
  'woot.com',
  'zappos.com',
  'zeframllc.com',
  'media-amazon.com',
  'thisissmallbusinesspodcast.com',
  'rumble.studio',
  'aboutamazon.com',
  'amzn.to',
  'gotowebinar.com',
];

const isValidAmazonLink = (url: string) => {
  try {
    // Convert url string to URL object to properly extract host/domain
    const { host } = new URL(url);
    // Return true if url isn't Amazon
    return validDomains.some((domain) => host === domain || host.endsWith(`.${domain}`));
  } catch (error) {
    return false;
  }
};

export default isValidAmazonLink;
